import { StyleSheet } from '@react-pdf/renderer';

// Create styles
// TODO: clean this code.
export const styles = StyleSheet.create({
  logo: {
    width: '170px',
    height: '54px',
    marginBottom: '30px'
  },
  page: {
    backgroundColor: '#fff',
    width: '100%',
    minHeight: '100vh',
    paddingLeft: '15px',
    paddingRight: '15px'
  },
  pageHeaderText: {
    fontSize: 10,
    fontStyle: 'Italic',
    marginBottom: 15
  },
  pageHeaderTitle: {
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 15
  },
  textLink: {
    textDecoration: 'underline',
    color: 'blue'
  },
  section: {
    // margin: 10,
    padding: 10,
    fontSize: 12
  },
  title: {
    fontSize: 12,
    marginBottom: 5,
    color: 'black',
    fontWeight: 'bold'
  },
  bigTitle: {
    fontSize: 35,
    color: 'red',
    marginBottom: 10
  },
  content: {
    fontSize: 12,
    marginBottom: 10,
    opacity: 0.7
  },
  sectionHeader: {
    fontSize: 14,
    fontWeight: 'bold',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 10,
    backgroundColor: '#F1F1F1',
    color: '#000000',
    textAlign: 'center',
    marginBottom: 10
  },
  sectionSubHeader: {
    color: '#003967',
    backgroundColor: '#F2F5F9',
    borderRadius: 5,
    padding: 15,
    marginBottom: 15
  },
  practices: {
    display: 'flex',
    marginBottom: 10,
    fontSize: 12
  },
  practicesContent: {
    marginBottom: 5
  }
});
